import { useState } from 'react'

import { Button } from '@/components/ui/button'

import { IosInstallSheet } from './ios-install-sheet'
import { useInstallPrompt } from './use-install-prompt'

/* ignores the dismissal the sidebar row honours, so "not now" still leaves a
 * way to install. */
export function InstallCard() {
  const { platform, dismissed, install, dismiss } = useInstallPrompt()
  const [iosOpen, setIosOpen] = useState(false)

  if (platform === 'none') return null

  return (
    <div className='flex w-full flex-col gap-4 rounded-2xl border border-border bg-page p-4 sm:p-6'>
      <div>
        <h2 className='text-[16px] font-semibold text-ink'>Install app</h2>
        <p className='mt-0.5 text-[13px] text-ink-soft'>
          {platform === 'ios'
            ? 'Add TandemOne to your Home Screen for a full-screen app with its own icon.'
            : 'Add TandemOne to your home screen or dock for a full-screen app with its own icon.'}
        </p>
      </div>
      <div className='flex flex-col gap-2 sm:flex-row'>
        {platform === 'ios' ? (
          <Button
            size='lg'
            className='w-full sm:w-auto'
            onClick={() => setIosOpen(true)}
          >
            Show me how
          </Button>
        ) : (
          <Button
            size='lg'
            className='w-full sm:w-auto'
            onClick={() => void install()}
          >
            Install
          </Button>
        )}
        {!dismissed && (
          <Button
            variant='ghost'
            size='lg'
            className='w-full sm:w-auto'
            onClick={dismiss}
          >
            Not now
          </Button>
        )}
      </div>
      <IosInstallSheet open={iosOpen} onOpenChange={setIosOpen} />
    </div>
  )
}
